import Vue from 'vue/dist/vue.esm.js';
import 'ion-rangeslider/js/ion.rangeSlider';
import {priceConverter} from "../utility/priceConverter";

Vue.component('range-filter', {
    template: '#range-filter',
    delimiters: ['[[', ']]'],
    props: {
        exchangeRate: {
            required: false,
            type: Number,
        },
        exchangeRateMode: {
            required: false,
            type: Number,
        },
        convertMode: {
            required: false,
            type: Number,
        },
        minRange: {
            required: true,
            type: Number,
        },
        maxRange: {
            required: true,
            type: Number,
        },

        imin: {
            required: true,
            type: Number,
        },
        imax: {
            required: true,
            type: Number,
        },
        attribute: {
            required: false,
            type: String,
        },
        property: {
            required: true,
            type: String,
        },
        locale: {
            required: true,
            type: String,
        },

    },

    data() {
        return {
            min: this.imin,
            max: this.imax,
        }
    },


    mounted() {
        if (this.min === 0) {
            this.min = this.minRange;
        }
        if (this.max === 0) {
            this.max = this.maxRange;
        }
        this.initSlider();
    },

    methods: {
        initSlider() {
            let sliderRefId = 'slider';
            if(this.attribute){
                sliderRefId += this.attribute;
            }
            sliderRefId = this.$refs[sliderRefId];

            let slider = $(sliderRefId).data("ionRangeSlider");

            if (slider) {
                slider.destroy();
            }

            let _self = this;
            $(sliderRefId).ionRangeSlider({
                skin: "round",
                type: "double",
                min: _self.minRange,
                max: _self.maxRange,
                hide_min_max: true,
                from: _self.min,
                to: _self.max,
                onStart: function () {
                    _self.updateMinMaxLabels();
                },
                onChange: function (data) {
                    _self.rangeChanged(data);
                    _self.updateMinMaxLabels();
                },
                onUpdate: function (data) {
                    _self.changeFilter(data);
                    _self.updateMinMaxLabels();
                },
                onFinish: function (data) {
                    _self.changeFilter(data);
                }
            });
        },

        rangeChanged(data) {
            this.min = data.from;
            this.max = data.to;
        },

        changeFilter(data) {

            let searchParams = new URLSearchParams(window.location.search);
            searchParams.set(this.property, data.from + ';' + data.to);

            searchParams.delete('page');
            history.replaceState(null, null, ' ');
            window.location.search = searchParams.toString();

        },
        changeMin() {
            let sliderRefId = 'slider';
            if(this.attribute){
                sliderRefId += this.attribute;
            }
            sliderRefId = this.$refs[sliderRefId];

            let slider = $(sliderRefId).data("ionRangeSlider");
            slider.update({
                from: this.min,
            })
        },
        changeMax() {
            let sliderRefId = 'slider';
            if(this.attribute){
                sliderRefId += this.attribute;
            }
            sliderRefId = this.$refs[sliderRefId];

            let slider = $(sliderRefId).data("ionRangeSlider");
            slider.update({
                to: this.max,
            })
        },
        updateMinMaxLabels(){
            let sliderRefId = 'range-slider';
            if(this.attribute){
                sliderRefId += this.attribute;
            }
            // if (this.property === 'price_range') {
            //     $('.' + sliderRefId + ' .irs-min').text(priceConverter(this.min, this.exchangeRate, this.exchangeRateMode, this.convertMode, '', this.locale) || 0);
            //     $('.' + sliderRefId + ' .irs-max').text(priceConverter(this.max, this.exchangeRate, this.exchangeRateMode, this.convertMode, '', this.locale) || 0);
            // }else{
                $('.' + sliderRefId + ' .irs-min').text(this.min);
                $('.' + sliderRefId + ' .irs-max').text(this.max);
            // }
        }

    }
    ,
    computed: {}
});